let Popup     = require('../components/Popup');

class Footer {
    constructor() {
        let contact = document.getElementsByClassName('js-contact')[0];

        contact.addEventListener('click', () => {
            let div = contact.getElementsByClassName('js-popin-contact')[0];

            div.classList.toggle('show');
        });

        new Popup('.js-legals-mentions');
    }
}

module.exports = Footer;